import React from 'react'
import {Container,Row,Col} from 'react-bootstrap'
import useGetData from '../custom-hooks/useGetData'
import { deleteDoc ,doc } from 'firebase/firestore'
import { db } from '../firebase.config'
import {toast} from 'react-toastify'

const User = () => {

    const {data:usersData,loading} = useGetData('users')

    const deleteUser = async (id)=>{
        await deleteDoc(doc(db,'users',id))
        toast.success('user deleted')
    }

    return (
        <section>
            <Container>
                <Row>
                    <Col lg='12'>
                        <h4 className='fw-bold'>
                            Users
                        </h4>
                    </Col>

                    <Col className='pt-5' lg='12'>
                        <table className='table'>

                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Username</th>
                                    <th>Email</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {
                                    loading ? <tr><td className='pt-5 border-0 fs-2 fw-bold'>Loading.....</td></tr> :
                                    usersData?.map((user,index)=>{
                                        return(
                                            <tr key={index}>
                                                <td><img src={user.photoURL} alt="User" /></td>
                                                <td>{user.displayName}</td>
                                                <td>{user.email}</td>
                                                <td><button onClick={()=>{deleteUser(user.uid)}} className='btn btn-danger'>Delete</button></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>

                        </table>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default User